export const minecraft1217 = {
  version: '1.21.7',
  title: 'A Minecraft Movie',
  alternativeTitle: 'Chase the Skies',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/screenshots/1.21.7-1170x500.jpg',
  alternativeImage: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/MCV_ChaseTheSkies_launch_Header_1170x500.jpg',
  hasImageSelector: true,
  imageOptions: [
    {
      key: 'movie',
      title: 'A Minecraft Movie',
      icon: '🎬',
      image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/screenshots/1.21.7-1170x500.jpg',
      description: 'Mostrando imagen de A Minecraft Movie'
    },
    {
      key: 'chase',
      title: 'Chase the Skies',
      icon: '🌤️',
      image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/MCV_ChaseTheSkies_launch_Header_1170x500.jpg',
      description: 'Mostrando imagen de Chase the Skies'
    }
  ],
  releases: [
    {
      id: "60aT4Noc",
      version: "1.0.4",
      date: "Jul 24, 2025",
      changelog: "Versión estable para Minecraft 1.21.7 con todos los mods actualizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.21.7",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    },
    {
      id: "140iY4Zwl",
      version: "beta-0.4-1.0.4",
      date: "Jul 8, 2025",
      changelog: "Nueva versión beta 0.4 para Minecraft 1.21.7 con mejoras adicionales y nuevas características. Incluye características tanto de A Minecraft Movie como de Chase the Skies",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.4-1.0.4-1.21.7",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "120hX2Wvj",
      version: "beta-0.3-1.0.4",
      date: "Jul 5, 2025",
      changelog: "Nueva versión beta 0.3 para Minecraft 1.21.7 con mejoras adicionales y nuevas características. Incluye características tanto de A Minecraft Movie como de Chase the Skies",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.3-1.0.4-1.21.7",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "110gX0Vui",
      version: "beta-0.2-1.0.4",
      date: "Jul 7, 2025",
      changelog: "Nueva versión beta 0.2 para Minecraft 1.21.7 con mejoras adicionales y correcciones de errores. Incluye características tanto de A Minecraft Movie como de Chase the Skies",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.2-1.0.4-1.21.7",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    },
    {
      id: "100fW9Uth",
      version: "beta-0.1-1.0.4",
      date: "Jul 1, 2025",
      changelog: "Nueva versión beta 0.1 para Minecraft 1.21.7 con mods básicos optimizados. Incluye características tanto de A Minecraft Movie como de Chase the Skies",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/0.1-1.0.4-1.21.7",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: true
    }
  ]
};